import axios from "axios";
import Config from "../config";

const checkStatusChatbotRoom = () => {
    return axios({
        method: "post",
        url: (Config.url || '') + "/api/chatbot/check-status-rooms",
        data: {}
    });
};

export default checkStatusChatbotRoom;
